let searchForm = $("#searchform, #searchform-mobile")

//////////////
//  Event   //
//////////////

//Open search menu with keyboard
searchForm.find('.icon').keypress(function (e) {
    if (e.keyCode === 13) {
        let form = $(this).parents("#searchform, #searchform-mobile").eq(0);
        openSearchBox(form)
    }
})
//Open search menu with click
searchForm.click(function() {
    openSearchBox($(this))
});
//Close search menu on click out of searchform
$(document).click(function(e) {
    let clicked = $(e.target);
    let parent = clicked.parents("#searchform, #searchform-mobile").eq(0);
    if (!parent.length) {
        searchForm.each(function() {
            closeSearchBox($(this))
        })
    }
});
//On submit form
$(document).on('submit', '#searchform, #searchform-mobile' ,function(e){
    let value = $(this).find("input[type=text]").val()
    let tagLength = $(this).find('.selected-autocomplete-list input[type=hidden]').length
    //Fix quote
    let searchText = value;
    let strictWords = searchText.match(/"(.*?)"/gm);
    if (strictWords) {
        strictWords.forEach((value, number) => {
            let oldVal = value
            let newVal = ""
            newVal = value.replaceAll(" ", "&nbsp;")
            // console.log(newVal);
            searchText = searchText.replace(oldVal, newVal);
        })
    }
    //
    if (value == "" && tagLength == 0) {
        e.preventDefault()
    } else {
        // console.log(searchText)
        closeSearchBox($(this))
        $(this).find("input[type=text]").val(searchText)
    }
});
//On click on icon call submit search
searchForm.find('.icon').click(function(e) {
    e.preventDefault()
    let parent = $(this).parents('.input-search').eq(0);
    let isOpen = parent.attr("aria-expanded")
    if (isOpen == 'true') $(this).parents('form').submit()
});
// //On input research
// searchForm.find("input[type=text]").keyup(async function() {
//     let form = $(this).parents('#searchform, #searchform-mobile').eq(0);
//     let parent = $(this).parents('.input-search').eq(0);
//     let lastWord = getLastWord($(this).val())
//     if (lastWord && lastWord !== "OU") {
//         let tags = await searchTag(lastWord)
//         let selectedTags = getSelectedTags(form)
//         parent.find('.autocomplete-list').html('')
//         tags.forEach(tag => {
//             if ((!selectedTags.includes(tag.term_id))) {
//                 parent.find('.autocomplete-list').append(
//                 "<div class='autocomplete-item' tabindex='0' data-id='"+tag.term_id+"' data-name='"+tag.name+"' data-slug='"+tag.slug+"'>" +
//                     "<p>"+tag.name+"</p>" +
//                 "</div>"
//                 )
//             }
//         });
//         if (tags.length) {
//             parent.addClass('view-autocomplete-list')
//         } else {
//             parent.removeClass('view-autocomplete-list')
//         }
//     } else {
//         parent.removeClass('view-autocomplete-list')
//     }
//     updateView()
// })
// On add Tag with click
$(document).on('click', '.input-search .autocomplete-item', function (e) {
    addTags($(this))
})
// On add Tag with keyboard
$(document).on('keypress', '.input-search .autocomplete-item', function (e) {
    if (e.keyCode === 13) addTags($(this))
});
//ON remove tag with click
$(document).on('click', '#searchform .remove-tag, #searchform-mobile .remove-tag', function (e) {
    let element = $(this).parent()
    setTimeout(() => element.remove(), 1)
    updateView()
})
// On add Tag with keyboard
$(document).on('keypress', '#searchform .remove-tag, #searchform-mobile .remove-tag', function (e) {
    if (e.keyCode === 13) {
        let element = $(this).parent()
        setTimeout(() => element.remove(), 1)
        updateView()
    }
});

//////////////////
//  FUNCTIONS   //
//////////////////

//Update view
function updateView() {
    searchForm.each(function () {
        let input = $(this).find("input[type=text]");
        let selectedTags = getSelectedTags($(this));
        if (input.val() || selectedTags.length) {
            $(this).find(".search-bubble").slideUp(200);
        } else {
            $(this).find(".search-bubble").slideDown(200);
        }
        let hasAutoComplet = $(this).find(".autocomplete-item").length
        if (hasAutoComplet && getLastWord(input.val())) {
            $(this).find(".input-search").addClass('view-autocomplete-list')
        }
    })
}

//Open searchBox
function openSearchBox(form) {
    form.addClass('active')
    form.find(".input-search").attr("aria-expanded", 'true')
    form.find("input[type=text]").focus()
    updateView()
}
//Close searchBox
function closeSearchBox(form) {
    let input = form.find('.input-search');
    input.removeClass('view-autocomplete-list')
    input.attr("aria-expanded", 'false')
    form.removeClass('active')
}

//Add tag to filter search
function addTags(element) {
    let form = $(this).parents('#searchform, #searchform-mobile').eq(0);
    let parent = element.parents('.input-search').eq(0);
    let input = parent.find('input[type=text]');
    let tag = element.data()
    let selectedTags = getSelectedTags(form)
    if (!selectedTags.includes(tag.id)) {
        searchForm.find('.selected-autocomplete-list').append(
            "<div class='selected-autocomplete-element' data-id='"+tag.id+"' data-slug='"+tag.slug+"'>" +
            "<input type='hidden' name='tags["+tag.slug+"]' value='"+tag.id+"'>" +
            "<p>"+tag.name+"</p>" +
            "<span tabindex='0' class='remove-tag'></span>" +
            "</div>"
        )
        parent.removeClass('view-autocomplete-list')
        setTimeout(() => element.remove(), 1)
        removeLastWord(input)
        parent.find("input").focus()
    }
}
//Get search tag
async function searchTag($tag) {
    let args = {}
    args['tag'] = $tag
    return await fetch(resturl+'gettags', {
        method: 'POST',
        headers: {'Accept': 'application/json'},
        body: JSON.stringify(args),
    }).then(function (res) {
        if (res.ok) return res.json()
    }).then(function (data) {
        return data
    }).catch(function (error) {
        console.error(error)
    })
}
//Get last word of string
function getLastWord(baseValue) {
    let words = baseValue.split(' ')
    return words[words.length-1];
}
//Remove Last Word on input text
function removeLastWord(input) {
    let words = input.val()
    words = words.split(' ');
    delete words[words.length-1]
    let newWord = "";
    words.forEach((word) => newWord += word+" ")
    // newWord = newWord.substring(0, newWord.length - 1)
    input.val(newWord)
}

//Get selected tag by form
function getSelectedTags(selector) {
    let tags = []
    selector.find(".selected-autocomplete-element").each(function () {
        tags.push($(this).data('id'))
    })
    return tags
}
